import * as Immutable from "immutable";
import { globalUrl } from "./../utils/utils.jsx";

export const UserType = {
  CLIENT: `Client`,
  MEMBER: `Member`,
  OWNER: `Owner`,
};

const UserRecord = Immutable.Record({
  id: undefined,
  class: UserType.CLIENT,
  additional_email_addresses: Immutable.List(),
  daily_capacity: undefined,
  avatar_url: undefined,
  archived_on: undefined,
  company_id: undefined,
  created_by_id: undefined,
  created_on: undefined,
  custom_permissions: Immutable.List(),
  display_name: ``,
  email: undefined,
  first_name: ``,
  im_handle: undefined,
  im_type: undefined,
  is_archived: false,
  is_authenticator_validated: false,
  is_email_at_example: false,
  is_pending_activation: true,
  is_trashed: false,
  language_id: undefined,
  last_name: undefined,
  phone: undefined,
  short_display_name: ``,
  title: ``,
  trashed_by_id: undefined,
  trashed_on: undefined,
  updated_on: undefined,
  url_path: ``,
  has_custom_avatar: false,
  avatar_version: ``,
});

class User extends UserRecord {
  isOwner() {
    return this.class === UserType.OWNER;
  }

  isMember() {
    return this.class === UserType.MEMBER;
  }

  isMemberFinancialManager() {
    return this.isMember() && this.custom_permissions.indexOf(`can_manage_finances`) > -1;
  }

  isFinancialManager() {
    return this.isOwner() || (this.isMember() && this.custom_permissions.indexOf(`can_manage_finances`) > -1);
  }

  isClient() {
    return this.class === UserType.CLIENT;
  }

  isClientPlus() {
    return this.isClient() && this.custom_permissions.indexOf(`can_manage_tasks`) > -1;
  }

  isArchived() {
    return this.is_archived;
  }

  hasElevatedPermissions() {
    return !this.isClient() || this.isClientPlus();
  }

  // @todo: refactor remove, used by TeamTimeline and ProjectsTimeline containers
  isLoggedUser() {
    // eslint-disable-next-line no-undef
    return this.id === angie.logged_user.id;
  }

  getName(short = false) {
    return short ? this.short_display_name : this.display_name;
  }

  getAvatarUrl(size) {
    let sizeInPixels = 40;

    if (size === `photo`) {
      sizeInPixels = 256;
    } else if (size === `small`) {
      sizeInPixels = 16;
    } else if (size === `large`) {
      sizeInPixels = 80;
    }
    return this.avatar_url.replace(`--SIZE--`, sizeInPixels);
  }

  getViewUrl() {
    return globalUrl(this.url_path);
  }
}

export default User;
